import { ModalContent } from "@nextui-org/react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { closeModal, updateAction } from "../../store/slices/unifiedBalanceSlice";
import CustomModal from "../CustomModal/CustomModal";
import styles from "../Layout/Layout.module.scss";
import ToastMessage from "../ToastMessage/ToastMessage";
import AccountSelector from "./modals/AccountSelector/AccountSelector";
import AllariaMasModal from "./modals/AllariaMasModal/AllariaMasModal";
import AllariaMasOnboardingModal from "./modals/AllariaMasOnboardingModal/AllariaMasOnboardingModal";
import AllariaMasSelector from "./modals/AllariaMasSelector/AllariaMasSelector";
import CreateAccountModal from "./modals/CreateAccountModal/CreateAccountModal";
import PreconfirmUnification from "./modals/PreconfirmUnification/PreconfirmUnification";
import SuccessUnification from "./modals/SuccessUnification/SuccessUnification";
import UnifiedAccountsModal from "./modals/UnifiedAccountsModal/UnifiedAccountsModal";
import { useModalBackGesture } from "../../hooks/useModalBackGesture";
import useScreenSize from "../../hooks/useScreenSize";

const UnifiedBalance = () => {
  const dispatch = useAppDispatch();

  const { openModal, action } = useAppSelector((state) => state.unifiedBalance);
  const { toast, toastContainer } = styles;
  const { isMobile } = useScreenSize();

  const handleBack = () => {
    switch (action) {
      case "ACCOUNTS_SELECTOR":
        dispatch(updateAction("INITIAL"));
        break;
      case "ALLARIAMAS_SELECTOR":
        dispatch(updateAction("ACCOUNTS_SELECTOR"));
        break;
      case "PRECONFIRM":
        dispatch(updateAction("ALLARIAMAS_SELECTOR"));
        break;
      case "CREATE_ACCOUNT":
        dispatch(updateAction("ACCOUNTS_SELECTOR"));
        break;
      default:
        dispatch(closeModal());
    }
  };

  useModalBackGesture({
    isOpen: openModal,
    onBack: handleBack,
  });

  return (
    <CustomModal
      isOpen={openModal}
      onClose={handleBack}
      hideCloseButton={action === "INITIAL"}
      isDismissable={!isMobile}
      classNames={!isMobile && action === "INITIAL" ? { base: "min-w-[42rem] max-w-[42rem]" } : undefined}
    >
      <ToastMessage
        messageId="allariaMasModal"
        position="top-right"
        className={toastContainer}
        toastClassName={toast}
      />
      <ModalContent>
        {() => (
          <>
            {action === "INITIAL" && <AllariaMasModal />}
            {action === "ACCOUNTS_SELECTOR" && <AccountSelector />}
            {action === "ALLARIAMAS_SELECTOR" && <AllariaMasSelector />}
            {action === "PRECONFIRM" && <PreconfirmUnification />}
            {action === "FEEDBACK_SUCCESS" && <SuccessUnification />}
            {action === "NEEDS_ONBOARDING" && <AllariaMasOnboardingModal />}
            {action === "CREATE_ACCOUNT" && <CreateAccountModal />}
            {action === "UNIFIED_ACCOUNTS_DATA" && <UnifiedAccountsModal />}
          </>
        )}
      </ModalContent>
    </CustomModal>
  );
};

export default UnifiedBalance;
